export const buildProjectsUpdateData = (altText, project) => {
  return {
    project: {
      coverImage: {
        imageInfo: {
          altText
        }
      },
      id: project.id,
      revision: project.revision
    }
  };
};
export const buildProjectItemsUpdateData = (altText, item) => {
  return {
    item: {
      id: item.id,
      image: {
        imageInfo: {
          altText
        }
      },
      projectId: item.projectId
    }
  };
};
export const buildPortfolioBulkUpdatePayload = (altTextData, portfolioProjectsMap) => {
  const payload = {
    items: [],
    projects: []
  };
  const projectsByProjectId = new Map();
  altTextData.forEach(_ref => {
    let {
      id,
      alt,
      entityId
    } = _ref;
    const portfolioProject = portfolioProjectsMap.get(entityId || '');
    if ((portfolioProject == null ? void 0 : portfolioProject.project.id) === id) {
      payload.projects.push(buildProjectsUpdateData(alt, portfolioProject.project));
    } else {
      const projectItem = portfolioProject == null ? void 0 : portfolioProject.items.find(item => item.id === id);
      if (projectItem) {
        const projectId = projectItem.projectId || '';
        const items = projectsByProjectId.get(projectId) || [];
        items.push(buildProjectItemsUpdateData(alt, projectItem));
        projectsByProjectId.set(projectId, items);
      }
    }
  });
  projectsByProjectId.forEach((items, projectId) => {
    payload.items.push({
      items,
      projectId,
      returnFullEntity: false
    });
  });
  return payload;
};
//# sourceMappingURL=bulk-update-portfolio-alt-text-payload.js.map